// extracted by mini-css-extract-plugin
export default {"button":"button_styles_button__RGoZY"};